export default __webpack_public_path__ + "static/media/PlocastaKomoraHladnjakGrejac.35e50fee.png";